import { useMeQuery } from 'codegen';

interface CurrentUserOrganizationIdResult {
  organizationId: number | null;
  loading: boolean;
}

export const useCurrentUserOrganizationId = (): CurrentUserOrganizationIdResult => {
  const { data, loading } = useMeQuery();

  const organizationId =
    data?.me?.__typename === 'CurrentAdminUser' ? data.me.organization?.id ?? null : null;

  return { organizationId, loading };
};
